import { useMemo } from 'react'
import { isEmpty } from 'lodash'

import {
	Card as MUICard,
	CardActionArea,
	CardContent,
	Stack,
	Typography,
	useMediaQuery,
	useTheme,
} from '@mui/material'

import { makeStyles } from '@mui/styles'
import { lighten } from '@mui/material/styles'

import { JOB_STATUS_INFO, STATUS_ICONS } from './helper/constant'
import { getFilteredRows } from '../../../../data/dataHelpers'

const CARD_SELECTED_BACKGROUND_COLOR = '#1976d214'
const CARD_BACKGROUND_COLOR = '#ffffff'

function buildStatusIcon(currentStatusInfo, color = null) {
	if (!currentStatusInfo) return null

	const statusIconProps = {
		style: {
			color: color || currentStatusInfo.iconColor,
		},
		fontSize: 'large',
	}

	const StatusIcon = STATUS_ICONS[currentStatusInfo.id]
	return <StatusIcon {...statusIconProps} />
}

const useStyles = makeStyles((theme) => ({
	card: {
		margin: '0 5px 5px 5px',
		border: '1px',
		borderRadius: '10px',
	},
	detail: {
		width: '150px',
		minWidth: '85px',
		[theme.breakpoints.down('sm')]: {
			width: '100px',
		},
	},
	iconContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
}))

export function JobStatusCard(props) {
	const { selectedJobStatusInfo, widgetItem, allRows, onActionAreaClick } = props
	const theme = useTheme()
	const isSmall = useMediaQuery(theme.breakpoints.down('sm'))

	const classes = useStyles()

	const currentStatusInfo = useMemo(
		() =>
			Object.values(JOB_STATUS_INFO)?.find(
				(statusIconInfo) => statusIconInfo.id === widgetItem?.icon
			),
		[widgetItem?.icon]
	)

	const countConditionsValue = useMemo(() => {
		if (isEmpty(widgetItem) || isEmpty(allRows)) return 0

		if (widgetItem?.operator === 'total') return allRows.length

		const filteredRows = getFilteredRows([widgetItem], allRows)
		return filteredRows.length
	}, [allRows, widgetItem])

	return (
		widgetItem && (
			<MUICard
				className={classes.card}
				sx={{
					backgroundColor:
						selectedJobStatusInfo?.id === widgetItem?.id
							? CARD_SELECTED_BACKGROUND_COLOR
							: CARD_BACKGROUND_COLOR,
				}}
			>
				<CardActionArea onClick={onActionAreaClick}>
					<CardContent>
						<div
							style={{
								display: 'flex',
								flexDirection: isSmall ? 'column' : 'row',
								alignItems: 'center',
								justifyContent: 'center',
								gap: isSmall ? '8px' : '16px',
							}}
						>
							<div id="card-content" className={classes.detail}>
								<Typography variant="subtitle2">{widgetItem?.label}</Typography>
								<Typography
									variant="h5"
									style={{
										color: widgetItem?.color || currentStatusInfo?.textColor,
										fontWeight: 'bold',
									}}
								>
									{countConditionsValue || 0}
								</Typography>
							</div>

							<div className={classes.iconContainer}>
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										backgroundColor: lighten(
											widgetItem?.color || currentStatusInfo?.iconColor,
											0.8
										),
										width: isSmall ? '40px' : '50px',
										height: isSmall ? '40px' : '50px',
										borderRadius: '50%',
									}}
								>
									{buildStatusIcon(currentStatusInfo, widgetItem?.color)}
								</div>
							</div>
						</div>
					</CardContent>
				</CardActionArea>
			</MUICard>
		)
	)
}
